(() => {
  const pageSize = 8;
  function init() {
    const stories = Array.from(document.querySelectorAll('.pet-gallery__story, .love-gallery__story, .house-gallery__story'));
    if (!stories.length || document.querySelector('[data-gallery-pagination]')) return;
    const containers = [...new Set(stories.map(story => story.parentElement))];
    const pageCount = Math.ceil(stories.length / pageSize);
    const pagers = [];
    const top = document.createElement('div');
    top.id = 'gallery-pages';
    containers[0].before(top);
    const bottom = document.createElement('div');
    containers[containers.length - 1].after(bottom);
    [bottom].forEach(host => {
      host.className = 'gallery-pagination';
      host.dataset.galleryPagination = '';
      const status = document.createElement('p');
      status.className = 'gallery-pagination__status';
      status.setAttribute('aria-live', 'polite');
      const nav = document.createElement('nav');
      nav.setAttribute('aria-label', 'Artwork pages');
      host.append(status, nav);
      pagers.push({status, nav});
    });
    function pageUrl(page) {
      const url = new URL(window.location.href);
      if (page === 1) url.searchParams.delete('gallery_page');
      else url.searchParams.set('gallery_page', String(page));
      url.hash = 'gallery-pages';
      return url.pathname + url.search + url.hash;
    }
    function render(scroll) {
      const value = Number(new URL(window.location.href).searchParams.get('gallery_page'));
      const current = Number.isFinite(value) ? Math.max(1, Math.min(pageCount, Math.floor(value))) : 1;
      const start = (current - 1) * pageSize;
      stories.forEach((story, index) => {
        story.hidden = index < start || index >= start + pageSize;
        story.classList.toggle('gallery-page-first', index === start);
      });
      containers.forEach(container => {
        container.classList.add('gallery-page-container');
        container.hidden = !stories.some(story => story.parentElement === container && !story.hidden);
      });
      pagers.forEach(({status, nav}) => {
        status.textContent = `Works ${start + 1}–${Math.min(start + pageSize, stories.length)} of ${stories.length} · Page ${current} of ${pageCount}`;
        nav.replaceChildren();
        const addLink = (text, page, disabled = false) => {
          const element = document.createElement(disabled ? 'span' : 'a');
          element.className = 'gallery-pagination__link';
          element.textContent = text;
          if (disabled) element.setAttribute('aria-disabled', 'true');
          else {
            element.href = pageUrl(page);
            element.dataset.galleryPage = String(page);
            if (page === current) element.setAttribute('aria-current', 'page');
          }
          nav.append(element);
        };
        if (pageCount > 1) {
          addLink('Previous', current - 1, current === 1);
          for (let page = 1; page <= pageCount; page++) addLink(String(page), page);
          addLink('Next', current + 1, current === pageCount);
        }
      });
      if (scroll) {
        const heading = stories[start].querySelector('h2');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({preventScroll: true}); }
        top.scrollIntoView({block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
    }
    [bottom].forEach(host => host.addEventListener('click', event => {
      const link = event.target.closest('a[data-gallery-page]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      window.history.pushState(null, '', link.href);
      render(true);
    }));
    window.addEventListener('popstate', () => render(false));
    render(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
